import React, { useContext } from 'react'
import SystemChart from '../../shared/components/SystemChart'
import { ChartView, RechartData, useLegendState } from '../../../chart-kit/shared'
import { Moment } from '@e3dc-react/shell/Libs/moment'
import { useUserSettings } from 'src/Hooks'
import { DynamicPowerPricesEnabledContext } from 'src/Libs/dynamic-power-prices/context/dynamic-power-prices-enabled-context'
import { SaveChartProps } from 'src/Libs/system-data-handler/types'
import usePocPerformantChartLayout from '../hooks/use-poc-performant-chart-layout'
import { DASHBOARD_PERFORMANCE_VALUE_CHART_ID } from 'src/Libs/qa/ids'

interface Props {
  data: RechartData
  view: ChartView
  resolution?: ChartView
  handleSaveChart: (props: SaveChartProps) => void
  from: Moment
  to: Moment
  showForecast: boolean
}

/**
 * A proof of concept system chart using a potentially more performant history route
 *
 * @beta This logic is part of the system chart proof of concept and should not be made available to users yet
 */
const PocPerformantChart: React.FC<Props> = ({ data, view, resolution, handleSaveChart, from, to, showForecast }) => {
  const { isDynamicPowerPriceEnabled } = useContext(DynamicPowerPricesEnabledContext)
  const { userSettings } = useUserSettings()
  const { chartLayout, initialChartLayout } = usePocPerformantChartLayout(userSettings)
  const chartLayoutId = chartLayout.id ?? ''
  const { saveLegendState, hideLegend } = useLegendState(`${chartLayoutId}`)

  return (
    <SystemChart
      view={view}
      resolution={resolution}
      to={to}
      from={from}
      showForecast={showForecast}
      rechartData={data}
      loadingState={data.loadingState}
      customLayout={chartLayout}
      handleSaveChart={props => handleSaveChart({ customLayout: chartLayout, chartSettings: props })}
      maxHeight={chartLayout.maxHeight}
      isDynamicPowerPriceEnabled={isDynamicPowerPriceEnabled}
      hideLegend={hideLegend}
      initialChartLayout={initialChartLayout}
      toggleHideLegend={() => saveLegendState()}
      dataQa={DASHBOARD_PERFORMANCE_VALUE_CHART_ID}
    />
  )
}

export default PocPerformantChart
